// @flow
import { Outlet } from 'react-router';

const Manager = (): React$Node => {
  return <Outlet />;
};

export default Manager;
